import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "tabContent"]

  connect() {
    // Initialize with Overview tab as active
    this.showTab("overview")
  }

  switchTab(event) {
    event.preventDefault()
    const tabName = event.currentTarget.dataset.tab
    if (tabName) {
      this.showTab(tabName)
    }
  }

  showTab(tabName) {
    // Update tab button styling
    this.tabTargets.forEach(tab => {
      if (tab.dataset.tab === tabName) {
        tab.classList.add("profile-tab-button--active")
        tab.classList.remove("profile-tab-button--inactive")
      } else {
        tab.classList.remove("profile-tab-button--active")
        tab.classList.add("profile-tab-button--inactive")
      }
    })

    // Show/hide tab content
    this.tabContentTargets.forEach(content => {
      if (content.dataset.tabContent === tabName) {
        content.classList.remove("hidden")
      } else {
        content.classList.add("hidden")
      }
    })
  }
}
